import { createContext, useContext, useState } from "react";

const BookingContext = createContext(null);

export const BookingProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [presetPackage, setPresetPackage] = useState("");

  const openBooking = (pkg = "") => {
    setPresetPackage(pkg);
    setOpen(true);
  };

  return (
    <BookingContext.Provider value={{ open, setOpen, presetPackage, openBooking }}>
      {children}
    </BookingContext.Provider>
  );
};

export const useBooking = () => useContext(BookingContext);
